<template>
  <div id="app"  style="overflow-y: hidden;height: 100vh;">
    <div id="drag-preview-root"></div>
    <Header v-if="isShow && headerShow" ref="pageHeader"></Header> 
      <!-- <keep-alive include="class" :max="10"> -->
    <div style="padding-top: 76px;height: calc( 100% - 100px);">
      <keep-alive :include="cachedViews">
        <router-view v-if="isShow" :key="$route.fullPath" />
      </keep-alive>
    </div>  
       
    <Footer v-if="footerShow"></Footer>
  </div>
</template>
<script>
import Header from '@/components/layout/Header.vue'
import Footer from '@/components/layout/Footer.vue'
import { getLocalStorage,getSessionStorage } from '@/utils/auth'
import initPreviewRoot from '@/utils/previewRoot'
export default {
  components: {
    Header,
    Footer
  },
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews
    }
  },


  provide() {
    return {
      pageReload: this.pageReloadFlag,
      reloadNotice: this.reloadNoticeDot
    }
  },
  data() {
    return {
      isShow: true,
      headerShow: true,
      footerShow: true,
      orgAuthInfo: {}
    }
  },
  created() {
    //在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem("store"))))
    }
    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => { 
      sessionStorage.setItem("store", JSON.stringify(this.$store.state))
    })
  },
  watch: {
    $route: {
      immediate: true,
      handler: function (val, oldVal) {

        // 订单中心列表页面缓存（跳转订单详情保留订单列表数据，跳转其他页面清空）
        this.keepAlivePage()

        this.orgAuthInfo = getSessionStorage('orgAuthInfo')
        if (val.name == 'personal' || val.name == 'order' || val.name == 'settings' || val.name == 'orderDetail' || val.name == 'place' || val.name == 'orderInfoDetails' || val.name == 'orderDetail' || val.name == 'electron' || val.name == 'information' || val.name == 'informations' || val.name == 'orderCenter' || val.name == 'orderCenterElectron') {
          this.footerShow = false;
        } else {
          this.footerShow = true;
        }
        if (val.name == 'orgLogin') {
          this.footerShow = false;
          this.headerShow = false;
        }
        if (this.orgAuthInfo && this.orgAuthInfo.isOrg) {
          this.footerShow = false;
        }
      }
    },
  },
  mounted() {
    // 设置移动端
    this.useDeviceDetectorFn()
    // 初始化预览根元素
    initPreviewRoot()
  },
  methods: {
    // utils/device.js
    useDeviceDetectorFn() {
      const userAgent = window.navigator.userAgent.toLowerCase();
      const isMobile = /iphone|android|blackberry|windows phone/i.test(userAgent);
      const isTablet = /ipad/i.test(userAgent) || 
                      (/macintosh/i.test(userAgent) && window.navigator.maxTouchPoints > 1);
      const isNarrowScreen = window.innerWidth < 1024; // 宽屏阈值，可调整

      // 不是电脑设备，并且是窄屏
      const isMobileOrNarrowTablet = (isMobile || isTablet) && isNarrowScreen;
      
     

      if(isMobileOrNarrowTablet) {
        const appElement = document.getElementById('app');
        appElement.style.cssText = `overflow-y: auto; transition: transform 0.3s ease; transform: scale(0.5);  transform-origin: left top;  width: 200%;height: 200%;`;
        // appElement.style.cssText = `overflow-y: auto; transition: zoom 0.3s;  zoom: 0.5; transform-origin: left top; width: 200%;height: 200%;`
  
      }
    },
    keepAlivePage() {
      const { name } = this.$route

      // 订单中心列表页面缓存（跳转订单详情保留订单列表数据，跳转其他页面清空）
      if (name && name == "orderCenter") {
        this.$store.dispatch('tagsView/addView', this.$route)
      } else if (name && !(name == "orderCenter" || name == "informations" || name == "orderCenterElectron")) {
        this.$store.dispatch('tagsView/delView', this.$router.options.routes.find(item => item.name == "orderCenter"))
      }
    },

    pageReloadFlag() {
      // this.orgAuthInfo = getLocalStorage('orgAuthInfo')
      this.orgAuthInfo = getSessionStorage('orgAuthInfo')

      this.isShow = false;
      this.headerShow = false
      this.$nextTick(() => {
        this.isShow = true;
        this.headerShow = true
        if (this.orgAuthInfo && this.orgAuthInfo.isOrg) {
          this.footerShow = false;
          this.$router.push({ name: 'settings' })
        } else {
          this.$router.push({
            path: '/',
            query: {
              id: parseFloat(Math.random() * 1 + 1, 10)
            }
          })
        }
      })
    },
    reloadNoticeDot() {
      this.$refs.pageHeader.getNoticeStatus();
    }
  }
}

</script>

<style lang="scss" scoped>
// .home {
//   span {
//     color: red;
//   }
// }

</style>
